import React, { useEffect } from "react";
import { STREETEASY_SITE_CONTENT_SELECTOR } from "@streeteasy/design-system/constants/streeteasySiteContentSelector";
import { bool, func, shape, string } from "prop-types";

import KEYCODES from "src/shared/constants/key-codes";

import * as S from "./styled";

const DrawerModal = ({
  aria,
  disableClickOutside,
  handleOnClose,
  isOpen,
  modalContentProps,
  render,
  rootElementId,
  ...passThroughProps
}) => {
  const handleClose = () => {
    if (disableClickOutside) {
      return;
    }

    handleOnClose();
  };

  const handEscapeKeyPress = event => {
    if (event.keyCode === KEYCODES.ESCAPE) {
      handleClose();
    }
  };

  const dialogStyles = {
    position: "fixed",
    right: "-490px",
    top: "0"
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handEscapeKeyPress);
      document.querySelector("html").style.overflowY = "hidden";
    } else {
      document.removeEventListener("keydown", handEscapeKeyPress);
      document.querySelector("html").style.overflowY = "auto";
    }
  }, [isOpen]);

  return (
    <S.ContentWrapper
      aria={aria}
      closeTimeoutMS={500}
      dialogStyles={dialogStyles}
      isOpen={isOpen}
      onRequestClose={handleClose}
      rootElementId={rootElementId}
      {...passThroughProps}
    >
      <S.ModalContent data-qa="desktop-drawer-modal" {...modalContentProps}>
        {render(handleClose)}
      </S.ModalContent>
    </S.ContentWrapper>
  );
};

DrawerModal.propTypes = {
  aria: shape({
    describedby: string,
    labelledby: string
  }),
  disableClickOutside: bool,
  handleOnClose: func.isRequired,
  isOpen: bool.isRequired,
  modalContentProps: shape({}),
  render: func.isRequired,
  rootElementId: string
};

DrawerModal.defaultProps = {
  aria: {},
  disableClickOutside: false,
  modalContentProps: {},
  rootElementId: STREETEASY_SITE_CONTENT_SELECTOR
};

export default DrawerModal;
